<!--
 * @Author: Hyman Choi
 * @Date: 2021-01-11 10:25:08
 * @LastEditTime: 2021-01-27 10:28:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\views\home\index.vue
-->
<template>
  <div class="home-container">
    <div class="home-text" style="margin-bottom: 10px;">欢迎您，{{ name }}（ <span v-for="role in roles" :key="role">{{ role }} </span>）</div>
<!--    <el-tabs type="border-card">-->
<!--    <el-row>-->
<!--      <el-col :span="11">-->
<!--        <div class="block">-->
<!--          <span class="demonstration" style="text-align: center;display:block;margin-bottom: 10px">产品资料</span>-->
<!--          <el-carousel height="300px">-->
<!--            <el-carousel-item v-for="item in 7" :key="item">-->
<!--              <h3 class="small">{{ item }}</h3>-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--        </div>-->
<!--      </el-col>-->
<!--      <el-col :span="11" style="margin-left: 100px">-->
<!--        <div class="block" >-->
<!--          <span class="demonstration"  style="text-align: center;display:block;margin-bottom: 10px">学习资源</span>-->
<!--          <el-carousel trigger="click" height="300px">-->
<!--            <el-carousel-item v-for="item in 7" :key="item">-->
<!--              <h3 class="small">{{ item }}</h3>-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->
<!--    </el-tabs>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  computed: {
    ...mapGetters(['name', 'roles'])
  },
  item: 0,
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.home {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 20px;
    line-height: 46px;
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
